export default __webpack_public_path__ + "static/media/Cuisse of the Death Master (nm).f9f69ffa.jpg";